import React from 'react';
import { newsArticles } from '../../data/news';
import CyberNewsListTemplate from './CyberNewsListTemplate';

const CyberNewsExploitList: React.FC = () => {
  return <CyberNewsListTemplate 
    category="exploits"
    title="Actualités sur les Exploits Cybersécurité"
    description="Découvrez les dernières vulnérabilités et exploits critiques"
  />;
};

export default CyberNewsExploitList; 